<template>
  <transition name="FadeIn">
    <div
      class="Popup"
      v-if="forms.sharer.opened"
      @click.self="managePopupState({ popup: 'sharer', _state: false })"
    >
      <div class="Popup__inner">
        <div
          class="Popup__close"
          @click="managePopupState({ popup: 'sharer', _state: false })"
        >
          <span aria-label="Close Popup">&times;</span>
        </div>
        <div class="Popup__content">
          <h3>
            <i18n path="VUE.SHARE_TITLE.SHARE">
              <template #service>
                <span style="color: #2979FF">{{
                  $t("VUE.SHARE_TITLE.SERVICE")
                }}</span>
              </template>
            </i18n>
          </h3>

          <p style="text-align: center">
            {{ $t("VUE.SHARE_TITLE.SELECT_SN") }}
          </p>
          <div class="Popup__links">
            <ShareNetwork
              v-for="{ net, url, icon } in socials"
              :key="net"
              class="Popup__link"
              :network="net"
              :url="url"
              :title="$t('HELP_CENTER')"
              :description="$t('ABOUT_TEXT')"
              :quote="$t('ABOUT_TEXT')"
              hashtags="Некоммерческий проект, Helpcenter.life, Helpcenter.kz, Helpcenter.ru, Helpcenter.uz, центр взаимопомощи"
            >
              <img :src="require(`@/assets/images/socials/${icon}.png`)" alt />
            </ShareNetwork>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SharePopup",
  data: () => ({
    socials: [
      { net: "facebook", url: `https://helpcenter.life/`, icon: "facebook" },
      { net: "line", url: `https://helpcenter.life/`, icon: "line" },
      { net: "viber", url: `https://helpcenter.life/`, icon: "viber" },
      { net: "linkedIn", url: `https://helpcenter.life/`, icon: "linkedin" },
      { net: "vk", url: `https://helpcenter.life/`, icon: "vk" },
      { net: "telegram", url: `https://helpcenter.life/`, icon: "telegram" },
      { net: "whatsapp", url: `https://helpcenter.life/`, icon: "whatsapp" },
      { net: "baidu", url: `https://helpcenter.life/`, icon: "baidu" }
    ]
  }),
  computed: {
    ...mapGetters(["forms"])
  },
  methods: {
    ...mapMutations(["managePopupState"])
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.Popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 9999;
  background-color: rgba(#000, 0.1);

  &__inner {
    position: relative;
    max-height: 80vh;
    padding: 40px 30px 30px;
    margin: 5rem 0 0;
    overflow-y: auto;
    background-color: $sec_bg;
    border-radius: 10px;
    box-shadow: 0 0 10px 1px rgba(#000, 0.1);

    &::-webkit-scrollbar {
      width: 0.2px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $aux_bg;
    }
  }

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    text-align: center;
    cursor: pointer;

    span {
      display: block;
      font-size: 28px;
      font-weight: $b_fw;
      color: $prim_c;
      line-height: 30px;
      transition: color 0.2s;
    }

    &:hover {
      span {
        color: $aux_c;
      }
    }
  }

  &__content {
    max-width: 600px;
    text-align: center;
    color: $prim_c;

    h2 {
      font-size: 30px;
      line-height: 1.2;
    }

    h3 {
      margin: 0 0 10px;
      font-size: 22px;
      line-height: 1.2;
    }

    p {
      margin: 0 0 10px;
      text-align: left;
    }
  }

  &__video {
    margin: 30px 0 0;

    video {
      width: 100%;
      height: auto;
    }
  }

  &__links {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 20px 0 0;
  }

  &__link {
    display: inline-block;
    cursor: pointer;
    margin: 5px;
  }

  @media screen and(min-width: $min_lg) {
    &__content {
      h2 {
        font-size: 30px;
      }
    }

    &__video {
      video {
        max-width: 80%;
      }
    }

    &__text {
      padding: 30px 20px 10px;
    }
  }

  @media screen and(max-width: $max_md) {
    &__content {
      h2 {
        font-size: 32px;
      }
    }

    &__video {
      video {
        max-width: 90%;
      }
    }

    &__text {
      padding: 30px 0 10px;
    }
  }
}
</style>
